// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  FEEDS_SET_FEEDS,
} from './constants';

export function setFeeds(feeds) {
  return {
    type: FEEDS_SET_FEEDS,
    data: feeds
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_SET_FEEDS:
      let nextState = Object.assign({}, state, {news: action.data})
      return {
        ...nextState,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/setFeeds.js